import { render, staticRenderFns } from "./taskView.vue?vue&type=template&id=74cf2b14&scoped=true&"
import script from "./taskView.vue?vue&type=script&lang=js&"
export * from "./taskView.vue?vue&type=script&lang=js&"
import style0 from "./taskView.vue?vue&type=style&index=0&id=74cf2b14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cf2b14",
  null
  
)

export default component.exports